import { useEffect, useRef } from 'react';
import { useLatestRef } from './use-latest-ref';

/**
 * Runs `fn` once, the first time `when` is true (after mount by default). Never runs it again for
 * the life of the component, including React's development double-invoke of effects. For one-shot
 * side effects such as a redirect, a logout or a request that must not be sent twice.
 */
export function useRunOnce(fn: () => void, when = true): void {
  const fnRef = useLatestRef(fn);
  const hasRun = useRef<boolean>(false);

  useEffect(() => {
    if (!when || hasRun.current) {
      return;
    }
    hasRun.current = true;
    fnRef.current();
  }, [when]);
}
